const promises = [
  {
    icon: "ri-hand-heart-line",
    title: "Feito à mão",
    desc: "Produção em pequenos lotes.",
  },
  {
    icon: "ri-truck-line",
    title: "Frete grátis acima de R$ 199",
    desc: "Envio em até uma semana.",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "Trocas em até 30 dias",
    desc: "Sem burocracia.",
  },
  {
    icon: "ri-gift-2-line",
    title: "Embalagem para presente",
    desc: "Em todos os pedidos.",
  },
];

export default function TrustStrip() {
  return (
    <section className="w-full bg-secondary-50 border-y border-background-200/60 px-4 md:px-8 py-6">
      <div className="max-w-[1280px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
        {promises.map((p) => (
          <div key={p.title} className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center text-primary-600 shrink-0">
              <i className={`${p.icon} text-[17px]`}></i>
            </div>
            <div>
              <p className="text-[13.5px] font-medium text-foreground-900">{p.title}</p>
              <p className="text-[12.5px] text-foreground-600 leading-snug mt-0.5">
                {p.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}